var map = {
	"./translations.de": [
		"./src/i18n/translations.de.js",
		"src_i18n_translations_de_js"
	],
	"./translations.de.js": [
		"./src/i18n/translations.de.js",
		"src_i18n_translations_de_js"
	],
	"./translations.en": [
		"./src/i18n/translations.en.js",
		"src_i18n_translations_en_js"
	],
	"./translations.en.js": [
		"./src/i18n/translations.en.js",
		"src_i18n_translations_en_js"
	],
	"./translations.fr": [
		"./src/i18n/translations.fr.js",
		"src_i18n_translations_fr_js"
	],
	"./translations.fr.js": [
		"./src/i18n/translations.fr.js",
		"src_i18n_translations_fr_js"
	],
	"./translations.it": [
		"./src/i18n/translations.it.js",
		"src_i18n_translations_it_js"
	],
	"./translations.it.js": [
		"./src/i18n/translations.it.js",
		"src_i18n_translations_it_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/i18n lazy recursive ^\\.\\/translations\\..*$";
module.exports = webpackAsyncContext;